const state = {
  filters: {
    availability: null,
    region: null,
    bedrooms: null,
    plots: null,
    price: {
      display: null,
      min: null,
      max: null
    },
    purchaseType: null,
    style: null,
    type: null
  }
}

const mutations = {
  clearFiltersSiteplan (state, payload) {
    state.filters.availability = null
    state.filters.bedrooms = null
    state.filters.plots = null
    state.filters.purchaseType = null
    state.filters.style = null
    state.filters.type = null
    state.filters.region = null
    state.filters.price = {
      display: null,
      max: null,
      min: null
    }
  },
  setFilterAvailability (state, payload) {
    state.filters.availability = payload
  },
  setFilterBedrooms (state, payload) {
    state.filters.bedrooms = payload
  },
  setRegion (state, payload) {
    state.filters.region = payload
  },
  setFilterPlots (state, payload) {
    state.filters.plots = payload
  },
  setFilterPrice (state, payload) {
    state.filters.price.display = payload.display
    state.filters.price.min = payload.min
    state.filters.price.max = payload.max
  },
  setFilterPurchaseType (state, payload) {
    state.filters.purchaseType = payload
  },
  setFilterStyle (state, payload) {
    state.filters.style = payload
  },
  setFilterType (state, payload) {
    state.filters.type = payload
  }
}

export default {
  state,
  mutations
}
